import { render, staticRenderFns } from "./card-tips.vue?vue&type=template&id=89cddf6e&"
import script from "./card-tips.vue?vue&type=script&lang=ts&"
export * from "./card-tips.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports